/**
 * Toolbar notification badge — **demo value** until a notifications API exists.
 * Replace `ADMIN_TOOLBAR_DEMO_NOTIFICATION_COUNT` (or wire `AppToolbar` `notifications.count`
 * from React Query) when backend is ready.
 */
export const ADMIN_TOOLBAR_DEMO_NOTIFICATION_COUNT = 17;
